<template>
    <div id="app">
        <div class="browser-download-layer-cover" v-if="showDownloadBrowserLayer"></div>
        <div class="browser-download-layer" v-if="showDownloadBrowserLayer">
            <div class="title">
                멸치패밀리 사이트는 최신의 HTML5와 CSS3를 기반으로 개발된 시스템으로 현재<br>
                <span>익스플로러 9.0 이하</span>버전에서 원활한 서비스가 이뤄지지 않고 있습니다.<br>
                아래의 지원 브라우저 중에서 하나를 설치하시고 이용하시기 바랍니다.
            </div>
            <ul class="browser_down">
                <li>
                    <a href="https://www.google.com/intl/ko/chrome/browser/features.html" target="_blank">
                        <img src="./assets/images/common/img_chrome.png" alt="크롬 브라우저 다운로드">
                        <p>Google 크롬<br><span>다운로드</span></p>
                    </a>
                </li>
                <li>
                    <a href="http://www.mozilla.or.kr/ko" target="_blank">
                        <img src="./assets/images/common/img_firefox.png" alt="파이어폭스 브라우저 다운로드">
                        <p>Mozila 파이어폭스<br><span>다운로드</span></p>
                    </a>
                </li>
                <li>
                    <a href="http://windows.microsoft.com/ko-kr/internet-explorer/download-ie" target="_blank">
                        <img src="./assets/images/common/img_explorer.png" alt="익스플로러11 브라우저 다운로드">
                        <p>익스플로러 11<br><span>다운로드</span></p>
                    </a>
                </li>
            </ul>
        </div>
        <component :is="layout">
            <router-view/>
        </component>
    </div>
</template>
<script>
    const default_layout = "default";
    const {detect} = require('detect-browser')
    const browser = detect()

    export default {
        created() {
            this.checkBrowserCompatibility();
        },
        data: function () {
            return {
                showDownloadBrowserLayer: false,
            }
        },
        computed: {
            layout() {
                return (this.$route.meta.layout || default_layout) + '-layout';
            }
        },
        methods: {
            checkBrowserCompatibility() {
                // console.log(browser.name)
                // console.log(browser.version)
                if (browser.name == 'ie' && parseInt(browser.version) <= 10) {
                    this.showDownloadBrowserLayer = true
                }
            },
            hideLayerContent() {
                this.$store.state.showLayerContent = false
            },
            showLayerContent() {
                this.$store.state.showLayerContent = true
            },
        }
    }
</script>
<style>
    @import url(//fonts.googleapis.com/earlyaccess/notosanskr.css);

    * {
        font-family: Noto Sans KR, Noto Sans, Noto Sans CJK KR, sans-serif; 
    }

    /* reset */
    html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
    }

    img {
        border: none;
        height: auto;
    }

    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
        display: block;
    }

    body {
        line-height: 1;
    }

    ol, ul {
        list-style: none;
    }

    blockquote, q {
        quotes: none;
    }

    blockquote:before, blockquote:after, q:before, q:after {
        content: '';
        content: none;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    a {
        text-decoration: none;
        cursor: pointer;
    }

    /*override user agent stylesheet*/
    body {
        margin: 0;
    }

    ol, ul {
        margin-block-start: 0;
        margin-block-end: 0;
        margin-inline-start: 0;
        margin-inline-end: 0;
        padding-inline-start: 0;
    }

</style>
<style lang="scss">
    //browser download 안내
    div.browser-download-layer-cover {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000000;
        opacity: 0.6;
        z-index: 1000;
    }

    div.browser-download-layer {
        position: fixed;
        top: 50%;
        left: 50%;
        width: 500px;
        height: 300px;
        margin-left: -260px;
        margin-top: -160px;
        background: #ffffff;
        z-index: 1001;
        padding: 20px;

        div.title {
            margin-top: 30px;
            font-size: 13px;
            line-height: 140%;
            text-align: center;
            margin-bottom: 30px;
        }

        ul.browser_down {

            margin: 10px 0 10px -30px;
            text-align: center;

            a {
                color: #999999;
            }

            li {
                display: inline-block;
                font-size: 14px;
                margin: 0 5px;
            }
        }
    }

    //기본 input text 스타일
    input.text {
        vertical-align: middle;
        font-size: 14px;
        padding: 9px;
        border: 1px solid #e5e5e5;
        color: #999999;
        background: #ffffff;
        width: 238px;
    }

    textarea {
        vertical-align: middle;
        font-size: 14px;
        padding: 9px;
        border: 1px solid #e5e5e5;
        color: #999999;
        background: #ffffff;
        width: 238px;
    }

    //기본 테이블 스타일
    table {
        border-collapse: collapse;
    }

    table.default-table {
        width: 100%;
        border: 1px solid #d2d3d4;

        th {
            border: 1px solid #d2d3d4;
            background: #eceef1;
            padding: 15px 20px 12px 20px;
            font-size: 14px;
            color: #666666;
            text-align: left;
        }

        th.center {
            text-align: center;
        }

        td {
            border: 1px dashed #d2d3d4;
            border-right-style: solid;
            padding: 12px 20px;
            font-size: 14px;
            color: #666666;
        }

        td.center {
            text-align: center;
        }

        tr.fixed td {
            background: #def4ff;
        }

        td.important {
            background: #def4ff;
        }

        td.small {
            font-size: 12px;
        }
    }

    //컨텐츠 상세 테이블 스타일
    table.detail-table {
        width: 100%;
        border-collapse: collapse;
        border-top: 2px solid #d2d3d4;
        border-bottom: 2px solid #d2d3d4;

        th {
            border-bottom: 1px dashed #d2d3d4;
            padding: 15px 20px 12px 20px;
            font-size: 16px;
            color: #666666;
            text-align: center;
        }

        th.center {
            text-align: center;
        }

        td {
            border-bottom: 1px dashed #d2d3d4;
            padding: 12px 20px;
            font-size: 14px;
            color: #666666;
            line-height: 140%;

            a {
                color: #666666;
            }
        }

        td.center {
            text-align: center;
        }

        tr.fixed td {
            background: #def4ff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue